<div class="page-layout blank p-24" fusePerfectScrollbar>

    <div class="button-container">
        <!-- <button pButton pRipple icon="pi pi-filter" class="p-button-rounded p-button-secondary p-mr-2 pull-right"
            pTooltip="Advance Filter" tooltipPosition="top" (click)="openFilter()"></button>
        <button *ngIf="!isClockIn" pButton pRipple class="p-button-success pull-right p-mr-2" pTooltip="Clock In"
            tooltipPosition="top" (click)="openConfirmation()">
            Clock In
        </button>
        <button *ngIf="isClockIn" pButton pRipple class="p-button-warning pull-right p-mr-2" pTooltip="Clock Out"
            tooltipPosition="top" (click)="openConfirmation()">
            Clock Out
        </button> -->
        <button pButton pRipple class="p-button-warning pull-right p-mr-2" pTooltip="Generate QR"
            tooltipPosition="top" (click)="showQrDialog()">
            Generate QR
        </button>
    </div>

    <div class="card table-container">

        <p-table #dt [value]="clockInOutInfo" [scrollable]="true" scrollHeight="calc(100vh - 270px)" [rows]="10"
            [rowsPerPageOptions]="[10,25,50,100]" [paginator]="true" [rowHover]="true"
            styleClass="p-datatable-gridlines">

            <ng-template pTemplate="header">
                <tr>
                    <th>Date</th>
                    <th>Clock In</th>
                    <th>Clock Out</th>
                    <th>Total Time</th>
                    <th>Status</th>
                    <th>Thumb Remark</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
                <tr [ngClass]="{'highlight-row': isToday(rowData.thumbDate)}">
                    <td>{{ rowData.thumbDate | date: 'dd/MM/yyyy'}}</td>
                    <td>{{ rowData.clockIn | date: 'HH:mm:ss' }}</td>
                    <td>{{ rowData.clockOut ? (rowData.clockOut | date: 'HH:mm:ss') : 'N/A' }}</td>
                    <td>{{ formatTotalTime(rowData.totalTime) }}</td>
                    <td>
                        <i class="pi p-button-text" pButton style="padding: 0%;" [ngClass]="{
                                'pi-thumbs-up p-button-success': rowData?.status === 'Approved',
                                'pi-clock p-button-danger': rowData?.status === 'Pending',
                                'pi-thumbs-down p-button-warning': rowData?.status === 'Rejected'
                            }" [pTooltip]="rowData?.status === 'Approved' ? 'Approved' : 
                                         rowData?.status === 'Pending' ? 'Pending' : 'Rejected'" tooltipPosition="top">
                        </i>
                    </td>
                    <td>{{ rowData.thumbRemark}}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">
                        <div class="notFound">
                            No Clock-In/Out Data Available.
                        </div>
                    </td>
                </tr>
            </ng-template>

        </p-table>
    </div>
</div>

<p-dialog [(visible)]="filterDialog" [style]="{width: '300px', height: '200px'}" header="Filter" [modal]="true"
    styleClass="p-fluid" (onHide)="hideDialog()" [contentStyle]="{ 'overflow': 'visible' }">
    <ng-template pTemplate="content">
        <div class="p-field">
            <label for="month">Month</label>
            <p-calendar id="month" [(ngModel)]="selectedMonth" view="month" dateFormat="mm/yy"></p-calendar>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Reset" icon="pi pi-times" class="p-button-text p-button-danger"
            (click)="hideDialog()"></button>
        <button pButton pRipple label="Submit" icon="pi pi-check" class="p-button-text" (click)="clockInOut()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="confirmationDialog" [style]="{width: '300px', height: '160px'}" header="Confirmation"
    [modal]="true" styleClass="p-fluid" (onHide)="hideDialog()" [contentStyle]="{ 'overflow': 'visible' }">
    <ng-template pTemplate="content">
        <div class="p-field">
            <p *ngIf="!isClockIn">Are you want to clock in for the day?</p>
            <p *ngIf="isClockIn">Are you want to clock out for the day?</p>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text p-button-danger"
            (click)="hideDialog()"></button>
        <button *ngIf="!isClockIn" pButton pRipple label="Yes" icon="pi pi-check" class="p-button-text"
            (click)="createClockInOrOutEntry(ThumbApplicationType._1)"></button>
        <button *ngIf="isClockIn" pButton pRipple label="Yes" icon="pi pi-check" class="p-button-text"
            (click)="createClockInOrOutEntry(ThumbApplicationType._2)"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="isQrDialogVisible" [style]="{width: '300px', height: '360px'}" header="QR Code"
    [modal]="true" styleClass="p-fluid" (onHide)="hideQrDialog()" [contentStyle]="{ 'overflow': 'visible' }">
    <ng-template pTemplate="content">
        <img [src]="qrImage" alt="">
    </ng-template>
</p-dialog>